var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "package"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:gap-2 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Layanan",
      "url": "/package/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1), _c('div', {
    staticClass: "flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:justify-start"
  }, [_c('div', {
    staticClass: "w-3/5 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari nama kategori barang"
    },
    on: {
      "enter": _vm.doSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('LinkButton', {
          attrs: {
            "buttonText": "Lihat rincian",
            "url": `/package/detail/${entry.id}`,
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }) : column.field === 'id' ? _c('span', {
          staticClass: "block break-all",
          attrs: {
            "title": entry.id
          }
        }, [_vm._v(" " + _vm._s(entry.id) + " ")]) : column.field === 'description' ? _c('span', {
          staticClass: "block"
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(entry.description)
          }
        })]) : column.field === 'delivery_service_type' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm.getDeliveryType(entry.delivery_service_type)) + " ")]) : column.field === 'tnc' ? _c('span', {
          staticClass: "block"
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(entry.tnc)
          }
        })]) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }])
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }